<sharry-header [showBack]="showBack"></sharry-header>
<div class="search-engine search-results">
  @if (params$ | async; as params) {
    <div
      class="search-engine__header"
      [class.search-engine__header--busy]="busy">
      <div class="divider"></div>
      <div class="search-engine__header__grid">
        <div
          class="search-engine__header--active-filters"
          [class.search-engine__header--busy]="busy">
          @if (params.distance && params.prefix === 'location' && !params.region) {
            <button
              mat-button
              color="secondary"
              class="sharry-small rounded filter-active"
              (click)="onFiltersClick()">
              {{ params.distance + ' Km' }}
            </button>
          }
          <!--          @if (banner?.enableButtonShowOperators) {
            <span
              type="button"
              class="search-engine&#45;&#45;type-filter"
              [ngClass]="{ selected: showOperators() }"
              (click)="onShowOperators()">
              <a>{{ 'search-results.enable-button-show-operators' | i18next }}</a>
            </span>
          }-->
          @if (searchCategories$ | async; as searchCategories) {
            <button
              mat-button
              color="secondary"
              class="sharry-small rounded filter-active"
              [ngClass]="{ hidden: !(params.searchCategories | sharryArraify)?.length }"
              (click)="onFiltersClick('category')">
              {{ 'active-filters.categories' | i18next }}
              <span class="search-engine__header--active-filters--counter not-read-pin">{{
                (params.searchCategories | sharryArraify).length
              }}</span>
            </button>
          }
          @if (accessibilityCategories$ | async; as accessibilityCategories) {
            <button
              mat-button
              color="secondary"
              class="sharry-small rounded filter-active"
              [ngClass]="{ hidden: !(params.searchAccessibilityCategories | sharryArraify)?.length }"
              (click)="onFiltersClick('accessibilityCategory')">
              {{ 'active-filters.accessibility' | i18next }}
              <span class="search-engine__header--active-filters--counter not-read-pin">{{
                (params.searchAccessibilityCategories | sharryArraify).length
              }}</span>
            </button>
          }
          @if (_types()?.length) {
            @for (type of _types(); track type) {
              <span
                type="button"
                class="search-engine--type-filter"
                [ngClass]="{ selected: selectedTypes.includes(type) }"
                (click)="onKindSearch(type, true)">
                <a>{{ type | sharrySourceName: searchResultsFilterablesService.filterablesInline }}</a>
              </span>
            }
          }
          @if (!params.types?.length) {
            @if (searchQualifications$ | async; as searchQualifications) {
              @for (qualification of params.searchQualifications | sharryArraify; track qualification) {
                <button
                  mat-button
                  color="primary"
                  class="sharry-small rounded filter-active"
                  [style]="(params.searchQualifications | sharryArraify).length === 1 ? 'background: #ffebeb' : null"
                  [ngClass]="{ hidden: !(qualification | sharrySourceName: searchQualifications) }"
                  (click)="onKindSearch(qualification, false)">
                  {{ qualification | sharrySourceName: searchQualifications }}
                  @if ((params.searchQualifications | sharryArraify).length === 1) {
                    <sharry-icon
                      matPrefix
                      name="x-circle-fill"
                      svgClass="svg-icon"></sharry-icon>
                  }
                </button>
              }
            }
          }
        </div>
        <div class="search-engine__header--buttons">
          <button
            mat-stroked-button
            color="secondary"
            class="sharry-medium rounded"
            [class.active]="
              !!params.distance ||
              !!(params.types | sharryArraify)?.length ||
              !!(params.searchAccessibilityCategories | sharryArraify)?.length ||
              !!(params.searchCategories | sharryArraify)?.length ||
              !!(params.searchQualifications | sharryArraify)?.length ||
              !!(params.beginDate && params.endDate)
            "
            (click)="onFiltersClick()">
            <sharry-icon
              matPrefix
              registryName="sliders"
              svgClass="svg-icon"
              type="phosphor"></sharry-icon>
            <span class="is-not-mobile">{{ 'search-results.filters.filters' | i18next }}</span>
          </button>
          <a
            mat-stroked-button
            class="sharry-medium rounded"
            [routerLink]="['search-results' | routeTranslate, 'map']"
            [class.active-map]="params.mode === 'map'"
            (click)="onToggleMap($event)">
            <sharry-icon
              name="map-trifold"
              type="phosphor"
              svgClass="svg-icon"></sharry-icon>
            <span class="is-not-mobile">{{ 'search-results.map' | i18next }}</span>
          </a>
        </div>
      </div>
    </div>
  }
  <router-outlet></router-outlet>
</div>

<ng-template
  #mobileFiltersDialog
  let-data>
  <sharry-generic-dialog
    class="mobile-filters-dialog"
    footerType="template"
    [header]="{ type: 'onlyTitle', title: 'search-results.filters.filters' | i18next }"
    [footerTemplate]="footer"
    (cancel)="onClose()">
    <div>
      @if (searchCategories$ | async; as searchCategories) {
        <sharry-filter
          [noBorderTop]="true"
          [filterTitle]="'search-results.filters.categories'"
          [type]="'checkbox-list'"
          [expanded]="activeFilter.includes('category')"
          [filters]="$any(searchCategories)"
          [searchFilters]="data.searchCategories"></sharry-filter>
        @if (showAccessibility(data.searchTypes) || (data.searchCategories | sharryArraify).length) {
          @if (accessibilityCategories$ | async; as accessibilityCategories) {
            <sharry-filter
              [expanded]="activeFilter.includes('accessibilityCategory')"
              [filterTitle]="'search-results.filters.accessibility-categories'"
              [type]="'checkbox-list'"
              [filters]="$any(accessibilityCategories)"
              [searchFilters]="data.searchAccessibilityCategories"></sharry-filter>
            @if (data.prefix === 'location' && data.distance !== undefined && data.distance !== null) {
              <sharry-filter
                [filterTitle]="'Distanza'"
                [type]="'slider'"
                [(distance)]="data.distance"
                (distanceChange)="data.region = undefined">
              </sharry-filter>
            }
            <sharry-filter
              [filterTitle]="'search-results.filters.sharry-date'"
              [type]="'calendar'"
              [(dateRange)]="data.dateRange">
            </sharry-filter>
          }
        } @else {
          @if (data.prefix === 'location' && data.distance !== undefined && data.distance !== null) {
            <sharry-filter
              [filterTitle]="'Distanza'"
              [type]="'slider'"
              [(distance)]="data.distance"
              (distanceChange)="data.region = undefined">
            </sharry-filter>
          }
        }
      }
    </div>
    <ng-template #footer>
      <div class="mobile-filters-dialog__footer">
        <button
          class="sharry-simple"
          (click)="clearSearch()">
          {{ 'search-results.filters.reset-filters' | i18next }}
        </button>
        <button
          mat-flat-button
          color="primary"
          class="sharry-medium"
          (click)="onSearch(data)">
          {{ 'search-results.filters.show-results' | i18next }}
        </button>
      </div>
    </ng-template>
  </sharry-generic-dialog>
</ng-template>
